// schema
import * as ISchema from "@schema";
// libraries
import React from "react";

// components
import { HoursAndPreferencesSections } from "../web-settings";

import { WorkPreferenceStartEndGoal } from "@components/goals-wrapper";

// util
// import { logger } from "@util/logger.util";

// styles
// import { colors, helpers } from "@clockwise/web-commons/src/styles/color.styles";

// material-ui
import { Typography } from "@material-ui/core";
// import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Time of Day Preference Settings
// ~-~-~-~-~-~-~-
interface WebSettingsTimeOfDayPreferenceProps {
  org: ISchema.IOrg;
}

// const useStyles = makeStyles({});

export const WebSettingsTimeOfDayPreference = (props: WebSettingsTimeOfDayPreferenceProps) => {
  // const classes = useStyles();

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  return (
    <div
      cw-id={`web-settings-${HoursAndPreferencesSections.TimeOfDayPreference}`}
      className="cw-mb-16"
    >
      <Typography variant="h3" className="cw-mb-4">
        Do you prefer to have open time at the start or end of your day?
      </Typography>
      <WorkPreferenceStartEndGoal org={props.org} isWebSettings />
    </div>
  );
};
